// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { Models, NodeID } from "@hex-insights/app-modules";
import { useModelIDsQuery } from "./GraphQL";

export function useModelFromID(id: NodeID) {
	return Models.useModelFromID(id, useModelIDsQuery);
}
